import CONFIG from "config/config";
import { isLocal, getPosthogCrossDomainParams } from "pages/flyer/upload/utils";
import posthog from "posthog-js";

const initPosthog = (): void => {
  const enablePosthog = typeof posthog.init === "function" && CONFIG.POSTHOG_KEY && CONFIG.POSTHOG_HOST;

  if (enablePosthog) {
    try {
      const { distinct_id, session_id } = getPosthogCrossDomainParams();
      const posthogConfig: any = {
        api_host: CONFIG.POSTHOG_HOST,
        disable_web_experiments: !isLocal() ? false : true, // false enables.
        bootstrap: {},
      };
      if (distinct_id) {
        posthogConfig.bootstrap.distinctID = distinct_id;
      }
      if (session_id) {
        posthogConfig.bootstrap.sessionID = session_id;
      }
      posthog.init(CONFIG.POSTHOG_KEY || "", posthogConfig);
    } catch (error) {
      console.log({
        message: "Error while initializing PostHog",
        error,
      });
    }
  }
};

export default initPosthog;
